import React, { FC, Fragment, useCallback, useEffect, useState } from 'react'
import { makeStyles, createStyles } from '@material-ui/core'
import { CourierServiceTable } from './CourierServiceTable'
import { Status } from '../../hooks/useFetchState'
import { useApi } from '../../hooks/useApi'
import { usePagination } from '../../hooks/usePagination'
import { useNotification } from '../../hooks/useNotification'
import { ApiResponse } from '../../typings/ApiResponse'
import { CourierServiceDto } from './DTO/CourierServiceDto'
import { CourierServiceCreate } from './CourierServiceCreate'
import { CourierServiceEdit } from './CourierServiceEdit'
import { LoadingButton } from '../../components/_EOS/Button/LoadingButton'
import { AlertDialog } from '../../components/Dialog/AlertDialog'
import { SnackBar } from '../../components/Notification/Snackbar'
import { getList, remove } from './api'


interface Props {
    courierId: number
}

export const CourierServiceList: FC<Props> = (
    {
        courierId
    }
) => {
    const styles = useStyles()
    const { state, callApi } = useApi<ApiResponse<CourierServiceDto>>()

    const [createModalOpen, setCreateModalOpen] = useState(false)
    const [updateModalOpen, setUpdateModalOpen] = useState(false)
    const [currentCourierService, setCurrentCourierService] = useState<CourierServiceDto>({ courierId: 0, courierServiceId: 0, serviceCode: '', serviceName: '', active: false })
    const [currentCourierServiceId, setCurrentCourierServiceId] = useState(0)
    const [openDialog, setOpenDialog] = useState(false)

    const pagination = usePagination(5)
    const notification = useNotification()

    const fetchData = (page?: number, pageSize?: number) => {
        const pageParameter = page !== undefined ? page : pagination.page
        const pageSizeParameter = pageSize !== undefined ? pageSize : pagination.pageSize
        callApi(getList(courierId, pageParameter, pageSizeParameter))
    }

    useEffect(() => {
        fetchData()
    }, [])

    const handlePaginationChange = (page: number, pageSize: number) => {
        fetchData(page, pageSize)
        pagination.setPagination(page, pageSize)
    }


    const handleActionButton = useCallback(() => {
        setCreateModalOpen(true)
    }, [])

    const handleActionEditButton = useCallback((courierService: CourierServiceDto) => {

        setUpdateModalOpen(true)
        setCurrentCourierService(courierService)
    }, [])

    const handleDeleteAction = (id: number) => {
        setCurrentCourierServiceId(id)
        setOpenDialog(true)
    }

    const okDialogAction = () => {
        setOpenDialog(false)
        remove(currentCourierServiceId.toString())
            .then(() => {
                fetchData(pagination.page, pagination.pageSize)
            })
            .catch(() => {
                notification.notify("No se puede eliminar el registro del servicio del  courier en el sistema. Revise las dependecias asociadas", "error")
            })


    }

    const cancelDialogAction = () => {
        setOpenDialog(false)
    }

    const handleModalClose = (success?: boolean) => {
        if (success) {
            fetchData()
            pagination.reset()
        }
        setCreateModalOpen(false)
        setUpdateModalOpen(false)
    }

    return (
        <Fragment>
            <div className={styles.buttonContainer}>
                <LoadingButton loading={state.status === Status.Loading} onClick={handleActionButton}>
                    Agregar Servicio
                </LoadingButton>
            </div>
            <CourierServiceTable
                data={state.data?.items}
                buttonText='Configuración'
                info=''
                title=''
                buttonEditAction={handleActionEditButton}
                buttonDeleteAction={handleDeleteAction}
                pagination={{
                    totalItem: state.data?.totalItems || 0,
                    page: pagination.page,
                    pageSize: pagination.pageSize,
                }}
                onPaginationChange={handlePaginationChange}
            />
            <CourierServiceCreate id={courierId} open={createModalOpen} onClose={handleModalClose} />
            <CourierServiceEdit id={courierId} courierService={currentCourierService} open={updateModalOpen} onClose={handleModalClose} />
            <AlertDialog title='MCIM' dialogText='Está seguro de eliminar el servicio del courier del sistema?' dialogOpen={openDialog} onOkAction={okDialogAction} onCancelAction={cancelDialogAction}></AlertDialog>
            <SnackBar
                open={notification.snackBarOpen}
                setOpen={notification.handleSnackbar}
                message={notification.snackBarMessage}
                status={notification.snackBarStatus}
            ></SnackBar>

        </Fragment>
    )
}

const useStyles = makeStyles(
    createStyles({

        buttonContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'right',
        }
    })
)